import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import * as d3 from 'd3';

const styles = theme => ({
  card: {
    //margin:'auto',
    fontFamily: 'Nunito Sans Bold!important',
    boxShadow: 'none',
    width: '75%',
    minWidth: '300px',
    paddingLeft: '100px',
    height: '50px',
    textAlign: 'center',
    backgroundColor: 'rgba(255,255,255,0)',
  },
  cardHeader: {
    //backgroundColor:'#105269',
    color: '#fff',
  },
  statValue: {
    /*
    [theme.breakpoints.down('xs')]: {
      fontSize:'0.7rem',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize:'0.8rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize:'1.0rem',
    }, 
    [theme.breakpoints.up('lg')]: {
      fontSize:'1.2rem',
    }, 
    [theme.breakpoints.up('xl')]: {
      fontSize:'1.5rem',
    },
    */
    color: '#000000',
    fontFamily: 'Nunito Sans Bold!important',
    fontSize: '16pt',
    textAlign: 'center',
  },
  cardContent: {
    //borderRadius:'2px',
    //borderColor:'#d4d4d4',
    //borderWidth:'4px',
    //borderStyle:'solid',
  }
});

function plotIndicator(props) {
  const { classes } = props;

  let locale
    switch (props.lang) {
      case "de":
        locale = d3.timeFormatDefaultLocale({
          "decimal": ",",
          "thousands": ".",
          "grouping": [3],
          "currency": ["€", ""],
          "dateTime": "%a %b %e %X %Y",
          "date": "%d-%m-%Y",
          "time": "%H:%M:%S",
          "periods": ["AM", "PM"],
          "days": ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
          "shortDays": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
          "months": ["", "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
          "shortMonths": ["", "Jan", "", "Mar", "", "Mai", "", "Jul", "", "Sep", "", "Nov", ""]
        })
        break
      case "en":
        locale = d3.timeFormatDefaultLocale({
          "decimal": ",",
          "thousands": ".",
          "grouping": [3],
          "currency": ["€", ""],
          "dateTime": "%a %b %e %X %Y",
          "date": "%d-%m-%Y",
          "time": "%H:%M:%S",
          "periods": ["AM", "PM"],
          "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          "shortDays": ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
          "months": ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          "shortMonths": ["", "Jan", "", "Mar", "", "May", "", "Jul", "", "Sep", "", "Nov", ""]
        })
        break
      case "fr":
      default:
        locale = d3.timeFormatDefaultLocale({
          "decimal": ",",
          "thousands": ".",
          "grouping": [3],
          "currency": ["€", ""],
          "dateTime": "%a %b %e %X %Y",
          "date": "%d-%m-%Y",
          "time": "%H:%M:%S",
          "periods": ["AM", "PM"],
          "days": ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
          "shortDays": ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
          "months": ["", "janvier", "février", "mars", "avril", "mai", "juin", "juillet", "aôut", "septembre", "octobre", "novembre", "décembre"],
          "shortMonths": ["", "jan", "", "mar", "", "mai", "", "jui", "", "sep", "", "nov", ""]
        })
    }

    let inhabitant
    let hourIndicator
    //let perMonthAccordingToMode = (this.props.currentMode === 'realtime' ? '' : perMonth)
    switch (props.lang) {
      case "de":
        inhabitant = "Einwohner"
        hourIndicator = ":00"
        break;
      case "en":
        inhabitant = "inhabitant"
        hourIndicator = "h"
        break;
      case "fr":
      default:
        inhabitant = "habitant"
        hourIndicator = "h"

    }

  const unit = props.currentMode === 'realtime' ?
    (props.currentFilter === 'energy' ? "GWh" : (props.currentFilter === 'inhabitants' ? ("Wh/"+inhabitant) : "MWh/100 km²")) :
    (props.currentFilter === 'energy' ? "GWh" : (props.currentFilter === 'inhabitants' ? ("Wh/"+inhabitant) : "GWh/100 km²"))
  return (
    <div className={classes.statValue}>
      {parseFloat(props.value).toLocaleString('nl-BE') + " " + unit}
    </div>
    /*
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
      <Typography component="p" className={classes.statValue}>
          
          //  props.value?((Math.round(1000*parseFloat(props.value))/10)):
           
          {parseFloat(props.value).toLocaleString('nl-BE') + " " + unit}
        </Typography>
        {
        
        //  <Typography component="p" className={classes.statValue}>
        //    {' GWh'} 
        //  </Typography>
        
        }
      </CardContent>
    </Card>
    */
  );
}

plotIndicator.propTypes = {
  classes: PropTypes.object.isRequired,
  //value:PropTypes.string||PropTypes.number,
};

export default withStyles(styles)(plotIndicator);